function FleetGridletContentLuController(
  $timeout,
  fleetService,
  __env,
  $scope
) {
  const ctrl = this;
  const env = __env;
  
  ctrl.$onInit = () => {
    ctrl.sortType = 'consist';
    ctrl.sortReverse = false;
    ctrl.hasAllColumns = env.operator !== 'bakerloo';
    $scope.$emit('gridlet-register-export', {
      legacyFleetIds: true,
      excel: ctrl.exportToExcel,
      csv: ctrl.exportToCsv,
      isExporting: () => ctrl.fetching,
    });
  };

  ctrl.goToTrainPage = trainItem => {
    ctrl.onTrainSelect({
      $event: {
        trainItem: trainItem,
      },
    });
  };

  ctrl.setSortType = column => {
    ctrl.sortReverse = (ctrl.sortType === column) ? !ctrl.sortReverse : false;
    ctrl.sortType = column;
  };

  // Modified default implementation of the comparator
  ctrl.sorter = (o1, o2) => {
    let result = 0;
    const type1 = o1.type;
    const type2 = o2.type;

    if (type1 === type2) {
      let value1 = o1.value;
      let value2 = o2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = o1.index;
        if (isObject(value2)) value2 = o2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = type1 < type2 ? -1 : 1;
    }

    const sign = ctrl.sortType === 'status' || ctrl.sortType === 'dataReceived' ? -1 : 1;
    return sign * result;
  };

  const getParameters = () => {
    return {
      sortReverse: false,
      sortType: 'TRAIN'
    };
  };
  ctrl.exportToCsv = async () => {
    ctrl.fetching = true;
    await fleetService.exportToCsv(getParameters(), "fleet-info");
    ctrl.fetching = false;
  };
  ctrl.exportToExcel = async () => {
    ctrl.fetching = true;
    await fleetService.exportToExcel(getParameters(), "fleet-info");
    ctrl.fetching = false;
  };
}

angular
  .module('dashboardGridletDirectives')
  .controller('FleetGridletContentLuController', FleetGridletContentLuController);
